export interface ManualOfferForm {
    url: string;
    name: string;
    price: string;
}

export const EMPTY_FORM: ManualOfferForm = { url: '', name: '', price: '' };

const PREFIX = 'manual-offer-draft:';

const isEmpty = (form: ManualOfferForm): boolean =>
    !form.url.trim() && !form.name.trim() && !form.price.trim();

export const readDraft = (key: string): ManualOfferForm | null => {
    try {
        const raw = sessionStorage.getItem(PREFIX + key);
        return raw ? { ...EMPTY_FORM, ...JSON.parse(raw) } : null;
    } catch {
        return null;
    }
};

export const writeDraft = (key: string, form: ManualOfferForm): void => {
    try {
        if (isEmpty(form)) sessionStorage.removeItem(PREFIX + key);
        else sessionStorage.setItem(PREFIX + key, JSON.stringify(form));
    } catch {
    }
};

export const clearDraft = (key: string): void => {
    try {
        sessionStorage.removeItem(PREFIX + key);
    } catch {
    }
};